var _path, _path2, _g, _path3, _g2, _g3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep4(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 176,
    viewBox: "0 0 199 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_925_23441)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_925_23441)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M166.4 133.6H32.3C25.5 133.6 20 128.1 20 121.3V28.5998C20 21.7998 25.5 16.2998 32.3 16.2998H166.4C173.2 16.2998 178.7 21.7998 178.7 28.5998V121.3C178.7 128.1 173.2 133.6 166.4 133.6Z",
    fill: "#F9F9F9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_925_23441",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 16,
    width: 159,
    height: 118
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M166.4 133.6H32.3C25.5 133.6 20 128.1 20 121.3V28.5998C20 21.7998 25.5 16.2998 32.3 16.2998H166.4C173.2 16.2998 178.7 21.7998 178.7 28.5998V121.3C178.7 128.1 173.2 133.6 166.4 133.6Z",
    fill: "#F9F9F9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_925_23441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.841 10L38.0547 139.9",
    stroke: "#FFB6B7",
    strokeWidth: 8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1973 83.0898H11.4766",
    stroke: "#FFB6B7",
    strokeWidth: 8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3164 118.749H187.223",
    stroke: "#FFB6B7",
    strokeWidth: 8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 83.0895V10",
    stroke: "#FFB6B7",
    strokeWidth: 8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.328 23.3994V118.748",
    stroke: "#FFB6B7",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4071 10C84.2635 10 72 22.3221 72 37.6313C72 52.8471 99.5 90 99.5 90C99.5 90 127 52.8471 127 37.6313C126.907 22.3221 114.644 10 99.4071 10ZM99.4071 47.2462C94.1115 47.2462 89.8378 42.9522 89.8378 37.6313C89.8378 32.3104 94.1115 28.0163 99.4071 28.0163C104.703 28.0163 108.976 32.3104 108.976 37.6313C108.976 42.9522 104.703 47.2462 99.4071 47.2462Z",
    fill: "#23292C"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_925_23441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98 125.773V152H67.8938V125.773L56 104H85.2885L98 125.773Z",
    fill: "#FE7C7E"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_925_23441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98 125.773V152H128.106V125.773L140 104H110.712L98 125.773Z",
    fill: "#FFB6B7"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3984 126.6C55.1545 125.5 66.8275 121.3 73.7988 127.8C80.3648 133.9 79.9595 144.9 84.0126 148.8C85.4717 150.2 87.093 150.9 88.7953 150.9",
    stroke: "#FFB6B7",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110.602 151C110.602 151 114.249 149.3 114.574 142.6C114.979 134.6 114.249 117.4 124.22 116.4C132.569 115.6 133.785 130.8 136.46 133.6C139.135 136.4 143.999 136.1 143.999 136.1",
    stroke: "#FE7C7E",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_925_23441",
    x: 0,
    y: 0.299805,
    width: 198.7,
    height: 157.3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_925_23441"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_925_23441",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_925_23441",
    x: 36,
    y: 88,
    width: 82,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_925_23441"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_925_23441",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_925_23441",
    x: 78,
    y: 88,
    width: 82,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_925_23441"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_925_23441",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_925_23441"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 199,
    height: 176,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep4);
export default __webpack_public_path__ + "static/media/step-4.e135f6f1786e8ca5019dddf9031c4851.svg";
export { ForwardRef as ReactComponent };